name: # manifest field name analogue (меняешь тут, меняй и там)
    en: Name
    es: Nombre
    fr: Nom
    pt: Nome
    ru: Имя
address: # manifest field address analogue (меняешь тут, меняй и там)
    en: Address
    es: Dirección
    fr: Adresse
    pt: Endereço
    ru: Адрес
mileage:
    en: Mileage
    ru: Расстояние
    es: Kilómetro
    pt: Distância
    fr: Kilométrage
email:
    en: E-mail
    es: E-mail
    fr: E-mail
    pt: E-mail
    ru: 'Электронная почта'
city:
    en: City
    ru: Город
    es: Ciudad
    fr: Ville
    pt: Cidade
state:
    en: 'State / Province'
    es: Estado/Provincia
    fr: Région
    pt: 'Distrito / Concelho'
    ru: Область
country:
    en: Country
    es: País
    fr: Pays
    pt: País
    ru: Страна
postcode: # manifest field postcode analogue (меняешь тут, меняй и там)
    en: 'ZIP/Postal code'
    es: 'Marada'
    fr: 'Code postal'
    pt: 'Marada'
    ru: 'Индекс'
phone:
    en: Phone
    es: Telefono
    fr: Téléphone
    pt: Telefone
    ru: Телефон
description:
    en: Description
    es: Descripción
    fr: Description
    pt: Descrição
    ru: Описание
clientName:
    en: 'Client name'
    es: 'Nombre del cliente'
    fr: 'Nom client'
    pt: 'Nome do cliente'
    ru: 'Имя клиента'
website:
    en: Website
    es: 'Página Web'
    fr: Site
    pt: Website
    ru: Веб-сайт
customer:
    en: Customer
    es: Cliente
    fr: Client
    pt: Cliente
    ru: Клиент
vehicleRequirements:
    en: 'Vehicle requirements'
    es: 'Requerimientos del vehículo'
    fr: 'Propriétés véhicule'
    pt: 'Requisitos do veículo'
    ru: 'Требования к транспортному средству'
vehicleRequirement:
    en: 'Vehicle requirement'
    ru: 'Требование к ТС'
    es: 'Requerimiento del vehículo'
    pt: 'Requisito do veículo'
login:
    en: Login
    es: 'Inicio de sesión'
    fr: Identifiant
    pt: Utilizador
    ru: Логин
roles:
    en: Roles
    es: Roles
    fr: Rôles
    pt: Funções
    ru: 'Права пользователя'
apiAccess:
    en: 'API access'
    es: 'Acceso a la API'
    fr: 'Accès API'
    pt: 'Acesso API'
    ru: 'Доступ к API'
depot:
    en: Depot
    es: Depósito
    fr: 'Plateforme régionale'
    pt: Armazém
    ru: 'Региональный округ'
distributionCentre: # manifest field distributionCentre analogue (меняешь тут, меняй и там)
    en: 'Distribution centre'
    da: Kommunen
    es: 'Centro de Distribución'
    fr: 'Centre de distribution'
    pt: 'Centro de Distribuição'
    ru: 'Распределительный центр'
dispatcher:
    en: Dispatcher
    es: Despachador
    fr: Planificateur
    pt: Expedidor
    ru: Диспетчер
customer_service: 
    en: 'Customer service'
    es: 'Servicio al cliente'
    fr: 'Service client'
    pt: 'Serviço ao cliente'
    ru: 'Обслуживание клиентов'
areaOfControl:
    en: 'Area of control'
    es: 'Área de Control'
    fr: 'Zone de couverture'
    pt: 'Área de controlo'
    ru: 'Область контроля'
permissions:
    en: "User's permission"
    ru: 'Разрешения пользователя'
    pt: 'Permissões de usuário'
    es: 'Los permisos de usuario'
    fr: "L'autorisation de l'utilisateur"
accountAdministrator:
    en: 'Account Administrator'
    es: 'Cuenta Administrador'
    fr: 'Administrateur des comptes'
    pt: 'Administrador de conta'
    ru: 'Администратор аккаунта'
admin:
    en: 'Account Admin'
    es: 'Cuenta Administrador'
    fr: 'Administrateur des comptes'
    pt: 'Administrador de conta'
    ru: 'Администратор аккаунта'
performer:
    en: Performer
    es: Ejecutor
    fr: Opérateur
    pt: Programador
    ru: Исполнитель
interfaceLanguage:
    en: 'Interface language'
    es: 'Lenguaje del interface'
    fr: "Langue de l'interface"
    pt: Linguagem
    ru: 'Язык интерфейса'
language:
    en: Language
    es: Lenguaje
    fr: Langue
    pt: Linguagem
    ru: Язык
userSettings:
    en: 'User settings'
    es: 'Parametros de usuario'
    fr: 'Paramètres utilisateur'
    pt: 'Definições de utilizador'
    ru: 'Настройки пользователя'
customerService:
    en: 'Customer Service'
    es: 'Servicio al cliente'
    fr: 'Contrôle de planfact'
    pt: 'Serviço a cliente'
    ru: 'Обслуживание клиентов'
comment:
    en: Comment
    es: Comentario
    fr: Commentaires
    pt: Comentário
    ru: Комментарий
comments:
    en: Comments
    es: Comentarios
    fr: Commentaires
    pt: Comentários
    ru: Комментарий
latitude:
    en: Latitude
    es: Latitud
    fr: Latitude
    pt: Latitude
    ru: Широта
longitude:
    en: Longitude
    es: Longitud
    fr: Longitude
    pt: Longitude
    ru: Долгота
date: # manifest field date analogue (меняешь тут, меняй и там)
    en: Date
    es: Fecha
    fr: Date
    pt: Data
    ru: Дата
print: # manifest field print analogue (меняешь тут, меняй и там)
    ru: 'Печать'
    en: 'Print'
    fr: 'Imprimer'
    pt: 'Imprimir'
    es: 'Imprimir'
startTime:
    en: 'Start time'
    es: 'Hora de inicio'
    fr: 'Horaire de début'
    pt: 'Hora de iníco'
    ru: 'Время начала работы'
endTime:
    en: 'End time'
    es: 'Hora final'
    fr: 'Horaire de fin'
    pt: 'Hora de fim'
    ru: 'Время окончания работы'
attributes: # manifest field attr analogue (меняешь тут, меняй и там)
    en: Attributes
    es: Atributos
    fr: Attributs
    pt: Atributos
    ru: Атрибуты
addressPrefix:
    en: 'Address prefix'
    es: 'Prefijo de la dirección'
    fr: 'Préfixe adresse'
    pt: 'Prefixo morada'
    ru: 'Префикс адреса'
addressPrefixInfo:
    en:
        'This prefix will be added to addresses of orders for this DC during import or order creation through API. Use
        this to add country, region or city name if all your addresses are in same area and are missing that
        information.'
    es:
        'Este prefijo se añadirá a la dirección de los pedidos para este Depot. durante la importación o la creación del
        pedido a través del API. Usa esto para añadir país, región o nombre de la ciudad si todas tus direcciones están
        en la misma área y dicha información no está.'
    fr:
        "Ce préfixe sera ajouté aux adresses des commandes pour ce centre de distribution pendant l'import ou la
        création de commandes par API. Utilisez cette option pour ajouter des pays, régions ou villes si toutes vos
        adresses sont dans la même zone et ont besoin de cette information."
    pt:
        'Este prefixo vai ser adicionado às ordens deste Centro de Distribuição, durante a importação ou criação da
        ordem através de API. Use isto para adiciona, pais, região ou nome da cidade, se todos as moradas forem na mesma
        região e faltar esta infrmação.'
    ru:
        'Этот префикс будет добавлен к адресам заказов для этого РЦ во время импорта или создания заказа через API.
        Используйте это поле, чтобы добавить к адресам название страны, области, города, если все адреса находятся в
        одной местности'
driver:
    en: Driver
    es: Conductor
    fr: Conducteur
    pt: Condutor
    ru: Водитель
vehicle:
    en: Vehicle
    es: Vehículo
    fr: Véhicule
    pt: Veículo
    ru: Машина
other:
    en: Other
    ru: Другие
    fr: Autres
color:
    en: Color
    es: Color
    fr: Сouleur
    pt: Cor
    ru: Цвет
price:
    en: Price
    es: Precio
    fr: Prix
    pt: Preço
    ru: Цена
action:
    en: Actions
    es: Acciones
    fr: Actions
    pt: Ações
    ru: Действия
sameDay:
    en: 'Same day'
    es: 'Mismo día'
    fr: 'Le même jour'
    pt: 'Mesmo dia'
    ru: 'Этот день'
previousDay:
    en: 'Previous day'
    es: 'Día anterior'
    fr: 'Jour précédent'
    pt: 'Dia anterior'
    ru: 'Предыдущий день'
nextDay:
    en: 'Next day'
    es: 'Día siguiente'
    fr: 'Jour suivant'
    pt: 'Próximo dia'
    ru: 'Следующий день'
dayAfterTomorrow:
    en: 'Day + 2'
    es: 'Día + 2'
    fr: 'Jour + 2'
    pt: 'Dia + 2'
    ru: Послезавтра
dayPlus3:
    en: 'Day + 3'
    es: 'Día + 3'
    fr: 'Jour + 3'
    pt: 'Dia + 3'
    ru: 'День + 3'
dayPlus4:
    en: 'Day + 4'
    es: 'Día + 4'
    fr: 'Jour + 4'
    pt: 'Dia + 4'
    ru: 'День + 4'
schedulingZones:
    en: Territories
    es: Territorios
    fr: Territoires
    pt: Territórios
    ru: Территории
territories:
    en: Territories
    es: Territorios
    fr: Territoires
    pt: Territórios
    ru: Территории
password:
    en: Password
    es: Contraseña
    fr: 'Mot de passe'
    pt: Senha
    ru: Пароль
passwordConfirm:
    en: 'Confirm password'
    es: 'Confirmar contraseña'
    fr: 'Confirmer le mot de passe'
    pt: 'Confirmar senha'
    ru: 'Подтверждение пароля'
capacity: # manifest field capacity analogue (меняешь тут, меняй и там)
    en: Capacity
    es: Tamaño
    fr: Capacité 
    pt: Capacidade
    ru: Размер
volume: # manifest field volume analogue (меняешь тут, меняй и там)
    en: Volume
    es: Volumen
    fr: Volume
    pt: Volume
    ru: Объем
created:
    en: Created
    es: Creado
    fr: Créée
    pt: Criado
    ru: 'Дата создания'
dateTime:
    en: Date/Time
    es: Fecha/Hora
    fr: Date/Heure
    pt: 'Data / Hora'
    ru: Дата/Время
fileName:
    en: 'File name'
    es: 'Nombre del fichero'
    fr: 'Nom de fichier'
    pt: 'Nome do ficheiro'
    ru: 'Имя файла'
perShift:
    en: 'per shift'
    da: 'pr. vagt'
    es: 'por turno'
    fr: 'par quart de travail'
    pt: 'por turno'
    ru: 'в смену'
    us: 'per shift'
geoPointWarning:
    en: 'Do you mean'
    es: '¿Quieres decir'
    fr: 'Vous voulez dire'
    pt: 'Quer dizer'
    ru: 'Вы имели в виду'
orderCancellationReasons:
    en: 'Order cancellation reasons'
    es: 'Razones de la cancelación de los pedidos'
    fr: 'Motifs annulation commande'
    pt: 'Razões pedido de cancelamento'
    ru: 'Причины отмены заказа'
orderItemCancellationReasons:
    en: 'Order item cancellation reasons'
    fr:  Raisons d'annulation d'éléments de commande
    es: 'Razones de la cancelación del pedido del artículo'
    pt: 'Razões de cancelamento do item de pedido'
    ru: 'Причины отмены товара'
audit:
    en: 'History of changing'
    es: 'Histórico de cambios'
    fr: 'Historique des changements'
    pt: 'Histórico de alterações'
    ru: 'История изменений'
bulkChange:
    en: 'Bulk change'
    es: 'Cambio a granel'
    fr: Changement
    pt: 'Alteração em grupo'
    ru: 'Групповое редактирование'
someFieldsAreWrong:
    ru: 'Некоторые поля заполнены неправильно'
    en: 'Some fields are not filled out correctly.'
    fr: 'Certains champs ne sont pas remplis correctement.'
    pt: 'Alguns campos não estão preenchido de forma correta.'
    es: 'Algunos campos no se han completado correctamente.'
speedCorrectionFactor:
    en: 'Speed correction factor'
    es: 'Factor de corrección de la velocidad'
    fr: 'Correction rapide'
    pt: 'Velocidade fator de correção'
    ru: 'Поправочный коэффициент скорости'
group:
    en: Group
    es: Grupo
    fr: Groupe
    pt: Grupo
    ru: Группа
userRole:
    en: 'User role'
    es: 'Rol de usuario'
    fr: 'Rôle utilisateur'
    pt: 'Função do utilizador'
    ru: 'Роль пользователя'
user:
    en: User
    es: Usuario
    fr: Utilisateur
    pt: Utilizador
    ru: Пользователь
warningIsAccurate:
    en: 'The address could not be found. Please locate it on the map.'
    es: 'No se ha encontrado la dirección. Por favor, localizarlo en el mapa.'
    fr: 'Cette adresse est introuvable. Veuillez la localiser sur la carte.'
    pt: 'Não foi possível encontar esta morada. Por favor localize-a no mapa.'
    ru: 'Адрес не найден или требует уточнения. Пожалуйста, уточните расположение заказа на карте.'
type:
    en: Type
    es: Tipo
    fr: Type
    pt: Tipo
    ru: Тип
signature:
    en: Signature
    es: Firma
    fr: Signature
    pt: Assinatura
    ru: Подпись
radius:
    en: Radius
    es: Radio
    fr: Rayon
    pt: Raio
    ru: Радиус
time:
    en: Time
    es: Hora
    fr: Heure
    pt: Hora
    ru: Время
speed:
    en: Speed
    es: Velocidad
    fr: Vitesse
    pt: Velocidade
    ru: Скорость
filter:
    en: Filter
    es: Filtro
    fr: Filtrer
    pt: Filtro
    ru: Фильтр
clear:
    en: Clear
    es: Limpiar
    fr: Nettoyer
    pt: Limpar
    ru: Очистить
loading:
    en: Loading...
    es: Cargando...
    fr: 'Chargement en cours...'
    pt: 'A carregar...'
    ru: Загрузка...
breakTime:
    en: Break
    ru: Обед
    es: Descanso
    fr: Break
    pt: Descanso
noItems:
    en: 'No items'
    ru: 'Нет записей'
    es: 'Ningún artículo'
    fr: 'Pas d’objets'
    pt: 'Sem items'
all:
    en: All
    ru: Все
    es: Todo
    pt: Todos
    fr: Tout
value:
    en: Value
    es: Valor
    fr: Valeur
    pt: Valor
    ru: Значение
id:
    ru: Идентификатор
    en: ID
    fr: Réf.
    pt: ID
    es: Núm.
index:
    ru: 'Порядковый номер'
    en: 'Sequence number'
    fr: 'Numéro de séquence'
    pt: 'Número de sequência'
    es: 'Número de secuencia'
run:
    en: Run
    ru: Рейс
    es: Ejecutar
    pt: Rota
    fr: Tournée
dropAbbr:
    en: D
    ru: Д
    es: D
    pt: E
    fr: L
collectionAbbr:
    en: C
    ru: С
    es: C
    pt: R
    fr: C
order_singular:
    en: order
    ru: заказ
    es: pedido
    pt: ordem
    fr: commande
order_dual:
    en: orders
    ru: заказа
    es: pedidos
    pt: ordens
    fr: commandes
order_plural:
    en: orders
    ru: заказов
    es: pedidos
    pt: ordens
    fr: commandes
vehicle_singular:
    en: vehicle
    ru: машина
    es: vehículo
    pt: veículo
    fr: véhicule
vehicle_dual:
    en: vehicles
    ru: машины
    es: vehículos
    pt: veículos
    fr: véhicules
vehicle_plural:
    en: vehicles
    ru: машин
    es: vehículos
    pt: veículos
    fr: véhicules
driver_singular:
    en: driver
    ru: водитель
    es: conductor
    pt: condutor
    fr: driver
driver_dual:
    en: drivers
    ru: водители
    es: conductores
    pt: condutores
    fr: drivers
driver_plural:
    en: driver
    ru: водителя
    es: conductor
    pt: condutores
    fr: driver
drop:
    en: Drop
    ru: Доставка
    es: Entrega
    pt: Entrega
    fr: Livraison
collection:
    en: Collection
    ru: Сбор
    es: Recogida
    pt: Recolha
    fr: Collecte
# Dynamics
capacityLabel:
    en: Capacity label
volumeLabel:
    en: Volume label
capacityUnits:
    en: Capacity units
volumeUnits:
    en: Volume units
planned: 
    en: Planned
    ru: Запланирован
    es: Planificado
    pt: Planeado
    fr: Planifié
unplanned: 
    en: Unplanned
    ru: Не запланирован
    es: No planificado
    pt: Não planeado
    fr: Non planifié
for: 
    en: for
    ru: для
    es: para
    pt: para
    fr: pour